import {
    ChangeDetectionStrategy,
    Component,
    computed,
    HostBinding,
    input,
    output,
    ViewEncapsulation,
} from '@angular/core';
import { PrevNextButtonsComponent } from '@shared/carousel-animation/prev-next-buttons/prev-next-buttons.component';

@Component({
    selector: 'companyid-carousel-animation',
    imports: [PrevNextButtonsComponent],
    templateUrl: './carousel-animation.component.html',
    styleUrl: './carousel-animation.component.scss',
    encapsulation: ViewEncapsulation.Emulated,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CarouselAnimationComponent {
    public currentIndex = input.required<number>();
    public className = input<string>('');
    public contentItemsLength = input.required<number>();
    public onChangeSlide = output<number>();

    public translateX = computed(() => `translateX(${-this.currentIndex() * 100}`);

    @HostBinding('class')
    public readonly hostClassname = 'relative overflow-hidden w-full';

    public changeSlide(id: number): void {
        this.onChangeSlide.emit(id);
    }
}
